import { render, staticRenderFns } from "./customerTotal.vue?vue&type=template&id=7e58c3a2&scoped=true"
import script from "./customerTotal.vue?vue&type=script&lang=js"
export * from "./customerTotal.vue?vue&type=script&lang=js"
import style0 from "./customerTotal.vue?vue&type=style&index=0&id=7e58c3a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e58c3a2",
  null
  
)

export default component.exports